import * as React from 'react';
import { ArticleParagraph2, Responsive, UIHeading4, UIText3 } from '@cian/ui-kit';
import { IFactoid } from '../../../../types/project';
import * as styles from './Factoid.css';
import { clsx } from 'clsx';

type IFactoidProps = IFactoid;

export const Factoid: React.FC<IFactoidProps> = ({ fullTitle, title, value, id }) => {
  return (
    <div className={clsx(styles['factoid'], styles[`factoid--${id}`])}>
      <Responsive desktop>
        <div>
          <UIText3 color="text-secondary-default">{fullTitle}</UIText3>
          <UIHeading4>{value}</UIHeading4>
        </div>
      </Responsive>
      <Responsive tablet phone>
        <div className={styles['content']}>
          <UIHeading4>{value}</UIHeading4>
          <ArticleParagraph2 color="text-secondary-default">{title}</ArticleParagraph2>
        </div>
      </Responsive>
    </div>
  );
};
